// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TypesWorkflowOutput
 */
export interface TypesWorkflowOutput {
  /**
   *
   * @type {string}
   * @memberof TypesWorkflowOutput
   */
  text?: string;
}

/**
 * Check if a given object implements the TypesWorkflowOutput interface.
 */
export function instanceOfTypesWorkflowOutput(
  value: object,
): value is TypesWorkflowOutput {
  return true;
}

export function TypesWorkflowOutputFromJSON(json: any): TypesWorkflowOutput {
  return TypesWorkflowOutputFromJSONTyped(json, false);
}

export function TypesWorkflowOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesWorkflowOutput {
  if (json == null) {
    return json;
  }
  return {
    text: json['text'] == null ? undefined : json['text'],
  };
}

export function TypesWorkflowOutputToJSON(json: any): TypesWorkflowOutput {
  return TypesWorkflowOutputToJSONTyped(json, false);
}

export function TypesWorkflowOutputToJSONTyped(
  value?: TypesWorkflowOutput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    text: value['text'],
  };
}
